/* eslint-disable class-methods-use-this, dot-notation, react/no-access-state-in-setstate,  react/no-direct-mutation-state */

import SmallLogoFooter from '@gameday/common/components/form/Common/SmallLogoFooter'
import { GENDER_IDENTITY } from '@gameday/common/constants/common'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import cn from 'classnames'
import classNames from 'classnames/bind'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { Component } from 'react'
import { Link } from 'react-router-dom'

import * as validations from '../../helpers/validations'
import { checkPassword, passwordRegex } from '../../utils/validation'
import AlertMessage from '../AlertMessage'
import { PrimaryButton } from '../Button'
import CountrySelect from '../CountrySelect'
import { DatePicker } from '../DatePicker'
import DropDown from '../FormElement/DropDown'
import InputField from '../InputField'
import Paper from '../Paper'
import PasswordCheck from '../PasswordCheck'
import PhoneNumber from '../PhoneNumber'
import StatusLabel from '../StatusLabel'

const styles = theme => ({
  pageWrapper: {
    [theme.breakpoints.down(400)]: {
      padding: '30px 20px',
    },
    padding: '60px 30px 30px 30px',
    minHeight: 0,
  },
  logo: {
    maxWidth: '50%',
  },
  form: {
    width: '100%',
  },
  field: {
    marginBottom: '16px',
  },
  lastField: {
    marginBottom: '8px',
  },
  passwordCheck: {
    fontSize: theme.typography.fontSizeSm,
    padding: '16px',
  },
  passwordCheckHeader: {
    marginBottom: '8px',
  },
  strengthWord: {
    padding: '0 4px',
    borderRadius: '4px',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  noMatch: {
    margin: '8px 0',
  },
  navLink: {
    textAlign: 'center',
    padding: theme.spacing(4),
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
      texAlign: 'center',
      fontWeight: 500,
      fontSize: '15px',
    },
  },
  textBox: {
    paddingBottom: '1rem',
    textAlign: 'center',
  },
  info: {
    color: theme.status.successColor,
  },
  error: {
    color: theme.status.errorColor,
  },
  success: {
    color: theme.status.successColor,
  },
  FormSubHeading: {
    display: 'block',
    fontSize: theme.typography.fontSizeMed,
    fontWeight: theme.typography.fontWeightBolder,
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    textAlign: 'center',
  },
})

const genderFilterData = [
  {
    key: 'genderIdentity',
    value: Object.values(GENDER_IDENTITY).map(item => ({
      id: item.id,
      name: item.value,
    })),
  },
]

class SignUpPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fields: {
        firstname: {
          value: '',
          isError: false,
          errorMessage: 'First name is required.',
        },
        lastname: {
          value: '',
          isError: false,
          errorMessage: 'Last name is required.',
        },
        email: {
          value: '',
          isError: false,
          errorMessage: 'Email is required.',
        },
        confirmEmail: {
          value: '',
          isError: false,
          errorMessage: 'Confirm email is required',
        },
        genderIdentity: {
          value: '',
          isError: false,
          errorMessage: '',
        },
        birthDate: {
          value: '',
          isError: false,
          errorMessage: '',
        },
        country: {
          value: '',
          isError: false,
          errorMessage: '',
        },
        mobile: {
          value: '',
          countryCode: '',
          isError: false,
          errorMessage: '',
        },
        password: {
          value: '',
          isError: false,
          errorMessage: 'Password is required.',
        },
        confirmPassword: {
          value: '',
          isError: false,
          errorMessage: 'Confirm password is required.',
        },
      },
      charLength: false,
      capitalLetter: false,
      numberEntered: false,
      specialChar: false,
      passwordNotMatch: true,
      emailNotMatch: true,
      tooltipOpen: false,
      showPassword: false,
      showConfirmPassword: false,
      checkAutoFill: true,
    }
  }

  componentWillReceiveProps(nextProps) {
    const { formError } = nextProps
    if (formError.length > 0) {
      const fields = this.clearFields()
      this.setState({
        fields,
        charLength: false,
        capitalLetter: false,
        numberEntered: false,
        specialChar: false,
        passwordNotMatch: true,
        emailNotMatch: true,
      })
    }
  }

  clearFields = () => {
    const { fields } = this.state
    const { includePassword } = this.props
    fields.firstname.value = ''
    fields.firstname.isError = true
    fields.lastname.value = ''
    fields.lastname.isError = true
    fields.email.value = ''
    fields.email.isError = true
    fields.confirmEmail.value = ''
    fields.confirmEmail.isError = true
    if (includePassword) {
      fields.password.value = ''
      fields.password.isError = true
      fields.confirmPassword.value = ''
      fields.confirmPassword.isError = true
    }

    return fields
  }

  handleTooltipClose = () => {
    this.setState({ tooltipOpen: false })
  }

  handleTooltipOpen = () => {
    this.setState({ tooltipOpen: true })
  }

  handleGenderChange = value => {
    const { fields } = this.state
    const selectedOption = genderFilterData[0].value.find(option => option.id === value)
    const temp = { ...fields }
    temp.genderIdentity = {
      ...temp.genderIdentity,
      value: selectedOption?.name || '',
      id: value,
      isError: false,
      errorMessage: '',
    }
    this.setState({
      fields: temp,
    })
  }

  handleBirthDateChange = date => {
    const { fields } = this.state
    const temp = { ...fields }
    const today = new Date()
    const isFutureDate = date && new Date(date) > today
    temp.birthDate = {
      ...temp.birthDate,
      value: date,
      isError: isFutureDate,
      errorMessage: isFutureDate ? 'Birth date cannot be in the future.' : '',
    }
    this.setState({
      fields: temp,
    })
  }

  handleCountryChange = ({ selectedOption }) => {
    const { fields } = this.state
    const temp = { ...fields }
    temp.country = {
      ...temp.country,
      value: selectedOption,
      isError: false,
      errorMessage: '',
    }
    this.setState({
      fields: temp,
    })
  }

  handlePhoneNumberChange = ({ value, countryCode }) => {
    const { fields } = this.state
    let phoneNumberObj = null
    let isValid = false

    if (fields.mobile.countryCode && countryCode !== fields.mobile.countryCode) {
      this.setState({
        fields: {
          ...fields,
          mobile: {
            ...fields.mobile,
            value: '',
            countryCode,
            isError: false,
            errorMessage: '',
          },
        },
      })
      return
    }

    if (value) {
      try {
        phoneNumberObj = parsePhoneNumberFromString(String(value), countryCode)
        isValid = phoneNumberObj?.isValid() || false
      } catch (error) {
        console.error('Error parsing phone number:', error)
        isValid = false
      }
    }

    this.setState({
      fields: {
        ...fields,
        mobile: {
          ...fields.mobile,
          value: value || '',
          countryCode,
          isError: value ? !isValid : false,
          errorMessage: value && !isValid ? `Please enter a valid phone number for ${countryCode}` : '',
        },
      },
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { handleSubmit } = this.props
    const { fields } = this.state
    handleSubmit(fields)
  }

  onChange = (value, name) => {
    const { fields, passwordNotMatch, emailNotMatch } = this.state
    let isErr = false
    let errMsg = ''
    const temp = { ...fields }
    temp[name] = { ...temp[name] }
    temp[name].value = value

    if (name === 'firstname') {
      if (value.length === 0) {
        errMsg = validations.validateRequired(value, 'First Name')
      } else {
        errMsg = validations.validateMaxInputLengthOnly(value, 'First Name', 40, 'text')
      }

      if (errMsg) {
        isErr = true
      }
    }

    if (name === 'lastname') {
      if (value.length === 0) {
        errMsg = validations.validateRequired(value, 'Last Name')
      } else {
        errMsg = validations.validateMaxInputLengthOnly(value, 'Last Name', 40, 'text')
      }

      if (errMsg) {
        isErr = true
      }
    }

    if (name === 'email') {
      errMsg = validations.validateEmail(value)
      if (value.length > 80) {
        errMsg = validations.validateInputLength(value, 'Email', 0, 80, 'text')
      }

      if (fields.confirmEmail.value !== value) {
        if (!emailNotMatch) {
          this.setState({ passwordNotMatch: true })
        }
      } else if (emailNotMatch) {
        this.setState({ passwordNotMatch: false })
      }

      if (errMsg) {
        isErr = true
      }
    }

    if (name === 'confirmEmail') {
      errMsg = validations.validateRequired(value, 'Confirm Email')

      if (fields.email.value !== value) {
        if (value.length > 0) {
          errMsg = 'Email does not match'
        }
        if (!emailNotMatch) {
          this.setState({ emailNotMatch: true })
        }
      } else if (emailNotMatch) {
        this.setState({ emailNotMatch: false })
      }

      if (errMsg) {
        isErr = true
      }
    }

    if (name === 'genderIdentity') {
      temp[name].value = value
    }

    if (name === 'confirmPassword') {
      errMsg = validations.validateRequired(value, 'Confirm Password')

      if (fields.password.value !== value) {
        if (!passwordNotMatch) {
          this.setState({ passwordNotMatch: true })
        }
      } else if (passwordNotMatch) {
        this.setState({ passwordNotMatch: false })
      }

      if (errMsg) {
        isErr = true
      }
    } else if (name === 'password') {
      errMsg = validations.validateRequired(value, 'Password')
      if (this.state.checkAutoFill) {
        const passwordRequirements = checkPassword(
          // biome-ignore lint/complexity/useLiteralKeys: TODO
          temp['password'].value,
          this.charLength,
          this.capitalLetter,
          this.numberEntered,
          this.specialChar
        )
        this.setState({ ...this.state, ...passwordRequirements })
        this.state.checkAutoFill = false
      }
      errMsg = validations.validateRequired(value, 'Password')

      if (fields.confirmPassword.value !== value) {
        if (!passwordNotMatch) {
          this.setState({ passwordNotMatch: true })
        }
      } else if (passwordNotMatch) {
        this.setState({ passwordNotMatch: false })
      }

      if (value.length > 100) {
        errMsg = validations.validateInputLength(value, 'Email', 0, 100, 'text')
      }

      if (errMsg) {
        isErr = true
      }
    }

    temp[name].isError = isErr
    temp[name].errorMessage = errMsg
    this.setState({
      fields: temp,
    })
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  renderPasswordNotMatch = () => <StatusLabel icon="cross" iconSize={16} label="Password does not match" />

  renderFormError = () => {
    const { formError, useAlertBox, loginLink, classes } = this.props

    if (!formError) return null

    if (useAlertBox) {
      return (
        <div className={cn(classes.textBox)}>
          <AlertMessage variant="warning" show size="sm">
            We've noticed a GameDay Account already exists with that email address, please{' '}
            <Link
              to={loginLink}
              style={{
                color: 'inherit',
                textDecoration: 'underline',
              }}
            >
              go back to the form login screen
            </Link>{' '}
            and login using that email address. Alternatively, if you wish to proceed as a guest, please use an
            alternative email address.
          </AlertMessage>
        </div>
      )
    }

    return <div className={cn(classes.textBox, classes.error)}>{formError}</div>
  }

  render() {
    const {
      backgroundImage,
      classes,
      formInfo,
      formSuccess,
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      formError,
      loginLink,
      logo,
      signingUp,
      title,
      application,
      includePassword,
      buttonText,
      hierarchyCountryCode,
    } = this.props
    const { showConfirmPassword, showPassword } = this.state

    const {
      passwordNotMatch,
      emailNotMatch,
      charLength,
      capitalLetter,
      numberEntered,
      specialChar,
      tooltipOpen,
      fields,
    } = this.state

    const { firstname, lastname, email, confirmEmail, password, confirmPassword, birthDate, mobile } = fields
    const enableButton =
      (!passwordNotMatch && !emailNotMatch && charLength && capitalLetter && numberEntered && specialChar) ||
      !includePassword

    return (
      <>
        <Paper classes={{ root: classes.pageWrapper }} backgroundImage={backgroundImage} application={application}>
          {logo && <img className={cn(classes.logo)} src={logo} alt="logo" />}
          {formInfo.length > 0 ? <div className={cn(classes.textBox, classes.info)}>{formInfo}</div> : ''}
          {formSuccess ? <div className={cn(classes.textBox, classes.success)}>{formSuccess}</div> : ''}
          {this.renderFormError()}
          <div className={classes.FormSubHeading}>
            <p>{title}</p>
          </div>
          <form className={classes.form} onSubmit={this.handleSubmit}>
            <InputField
              className={classes.field}
              label="First name"
              name="firstname"
              id="firstname-field"
              dataTestId="firstNameField"
              value={firstname.value}
              inputProps={{ autoComplete: 'given-name' }}
              onChange={event => this.onChange(event.target.value, 'firstname')}
              placeholder="Please enter..."
              isRequired
              fullWidth
              withBorder
              errorText={firstname.isError ? firstname.errorMessage : ''}
            />
            <InputField
              className={classes.field}
              label="Last name"
              name="lastname"
              id="lastname-field"
              dataTestId="lastNameField"
              value={lastname.value}
              inputProps={{ autoComplete: 'family-name' }}
              onChange={event => this.onChange(event.target.value, 'lastname')}
              placeholder="Please enter..."
              isRequired
              fullWidth
              withBorder
              errorText={lastname.isError ? lastname.errorMessage : ''}
            />
            <InputField
              className={classes.field}
              label="Email"
              name="email"
              id="email-field"
              dataTestId="emailField"
              value={email.value}
              inputProps={{ autoComplete: 'email' }}
              onChange={event => this.onChange(event.target.value, 'email')}
              placeholder="Please enter..."
              errorText={email.isError ? email.errorMessage : ''}
              isRequired
              fullWidth
              withBorder
            />
            <InputField
              className={classes.field}
              label="Confirm Email"
              name="confirmEmail"
              id="confirm-email-field"
              value={confirmEmail.value}
              inputProps={{ autoComplete: 'email', onPaste: e => e.preventDefault() }}
              onChange={event => this.onChange(event.target.value, 'confirmEmail')}
              placeholder="Please enter..."
              errorText={confirmEmail.isError ? confirmEmail.errorMessage : ''}
              isRequired
              fullWidth
              withBorder
            />
            <DropDown
              label="Gender Identity"
              id="gender-identity"
              defaultOption
              defaultValue="Please Select"
              filterData={genderFilterData}
              onChange={this.handleGenderChange}
              selected={fields.genderIdentity.id}
              border
              fullWidth
              errorText={fields.genderIdentity.isError ? fields.genderIdentity.errorMessage : ''}
              isRequired={false}
              className={classes.field}
            />
            <DatePicker
              className={classes.field}
              label="Birth Date"
              id="birth-date-field"
              dataTestId="birthDateField"
              selectedDate={fields.birthDate.value}
              onDateChange={this.handleBirthDateChange}
              placeholder="Select birth date..."
              fullWidth
              withBorder
              errorText={fields.birthDate.isError ? fields.birthDate.errorMessage : ''}
              isRequired={false}
              format="DD/MM/YYYY"
              startYear={1900}
              endYear={new Date().getFullYear()}
            />
            <CountrySelect
              className={classes.field}
              label="Country"
              id="country-field"
              value={fields.country.value}
              onChange={this.handleCountryChange}
              placeholder="Select your country..."
              fullWidth
              withBorder
              errorText={fields.country.isError ? fields.country.errorMessage : ''}
              isRequired={false}
              countryLabelType="label"
              withFlags
              hierarchyCountryCode={hierarchyCountryCode}
            />
            <PhoneNumber
              className={classes.field}
              label="Mobile"
              id="phone-number-field"
              dataTestId="phoneNumberField"
              value={fields.mobile.value || ''}
              defaultCountry={fields.mobile.countryCode || 'AU'}
              onNumberChange={this.handlePhoneNumberChange}
              placeholder="Enter mobile number"
              errorText={fields.mobile.isError ? fields.mobile.errorMessage : ''}
              isRequired={false}
              fullWidth
              withBorder
              withFlags
            />

            {includePassword ? (
              <div>
                <Tooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  open={tooltipOpen}
                  disableFocusListener
                  disableTouchListener
                  title={<PasswordCheck password={password} onChange={newState => this.setState({ ...newState })} />}
                >
                  <InputField
                    className={classes.field}
                    label="Password"
                    name="password"
                    id="password-field"
                    value={password.value}
                    type={showPassword ? 'text' : 'password'}
                    inputProps={{
                      autoComplete: 'new-password',
                      pattern: passwordRegex,
                    }}
                    icon={showPassword ? <VisibilityOff /> : <Visibility />}
                    handleOnClickIcon={() =>
                      this.setState({
                        showPassword: !showPassword,
                      })
                    }
                    onChange={event => this.onChange(event.target.value, 'password')}
                    onFocus={() => this.handleTooltipOpen()}
                    onBlur={() => {
                      if (!(charLength && capitalLetter && numberEntered && specialChar)) {
                        const { fields } = this.state
                        const temp = { ...fields }
                        // biome-ignore lint/complexity/useLiteralKeys: TODO
                        temp['password'].isError = true
                        // biome-ignore lint/complexity/useLiteralKeys: TODO
                        temp['password'].errorMessage = 'Password strength criteria not met.'
                        this.setState({
                          fields: temp,
                        })
                      }

                      this.handleTooltipClose()
                    }}
                    errorText={password.isError ? password.errorMessage : ''}
                    isRequired
                    fullWidth
                    withBorder
                  />
                </Tooltip>

                <InputField
                  className={cn(classes.field, classes.lastField)}
                  label="Confirm Password"
                  name="confirmPassword"
                  id="confirmPassword-field"
                  dataTestId="confirmPasswordField"
                  value={confirmPassword.value}
                  type={showConfirmPassword ? 'text' : 'password'}
                  inputProps={{
                    autoComplete: 'new-password',
                    pattern: passwordRegex,
                  }}
                  icon={showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  handleOnClickIcon={() =>
                    this.setState({
                      showConfirmPassword: !showConfirmPassword,
                    })
                  }
                  onChange={event => this.onChange(event.target.value, 'confirmPassword')}
                  errorText={confirmPassword.isError ? confirmPassword.errorMessage : ''}
                  isRequired
                  fullWidth
                  withBorder
                />
                <div className={classes.noMatch}>
                  {passwordNotMatch && confirmPassword.value.length > 0 ? (
                    this.renderPasswordNotMatch()
                  ) : (
                    <div>&nbsp;</div>
                  )}
                </div>
              </div>
            ) : null}

            <PrimaryButton
              fullWidth
              disableRipple
              className={cn(classes.submit)}
              type="submit"
              id="submit-button"
              data-testid="signupButton"
              disabled={
                firstname.value.length === 0 ||
                lastname.value.length === 0 ||
                email.value.length === 0 ||
                (includePassword && password.value.length === 0) ||
                (includePassword && confirmPassword.value.length === 0) ||
                firstname.isError ||
                lastname.isError ||
                email.isError ||
                birthDate.isError ||
                mobile.isError ||
                (includePassword && password.isError) ||
                (includePassword && confirmPassword.isError) ||
                !enableButton
              }
            >
              {signingUp ? 'Processing...' : buttonText}
            </PrimaryButton>
          </form>
          <div className={classNames(classes.navLink)}>
            {/* eslint-disable-next-line */}
            <Link to={`${loginLink}`}>Back to Login</Link>
          </div>
        </Paper>
        <SmallLogoFooter />
      </>
    )
  }
}

SignUpPage.defaultProps = {
  backgroundImage: '',
  classes: [],
  formInfo: '',
  formSuccess: '',
  formError: '',
  loginLink: '',
  logo: '',
  signingUp: false,
  title: 'Sign up for a new account',
  application: '',
  includePassword: true,
  buttonText: 'Sign Up',
  useAlertBox: false,
}

const SignUpPageComponent = withStyles(styles)(SignUpPage)
SignUpPageComponent.displayName = 'SignUpPage'
export default SignUpPageComponent
